// extracted by mini-css-extract-plugin
module.exports = {"default":"Headline-module__default___4wRAJ"};